import React from 'react';
import { Col, Form, Row } from "react-bootstrap";
import { useSelector, useDispatch } from 'react-redux';

import messages from '../../assets/i18n'

export default function SustainabilityFilter() {

  const dispatch = useDispatch();

  const lang = useSelector(state => state.language.name);
  const filters = useSelector(state => state.sustainabilityFilter.filter);

  const sortMessages = messages[lang].sustainabilityFilterSort;

  const setFilters = (newFilters) => {
    dispatch({
      type: 'SET_SUSTAINABILITY_FILTER',
      filter: newFilters
    })
  };

  const onEnterFilter = (e) => {
    if (e.keyCode === 13) {
      dispatch({
        type: 'GET_SUSTAINABILITY_LIST',
        page: 1,
        filter: filters,
        cleanTable: true
      })
    }
  }

  const statusFilter = [
    { id: "", message: messages[lang].all },
    { id: "0", message: "AGUARDANDO APROVAÇÃO" },
    { id: "1", message: "APROVADO" },
    { id: "2", message: "REPROVADO" },
  ];

  const sortSustainability = [
    { id: "pedido asc",        message: sortMessages.pedidoAsc},
    { id: "pedido desc",       message: sortMessages.pedidoDesc},   
    { id: "fornecedor asc",    message: sortMessages.fornecedorAsc},   
    { id: "fornecedor desc",   message: sortMessages.fornecedorDesc},   
    { id: "dataCadastro asc",  message: sortMessages.dataCadastroAsc},   
    { id: "dataCadastro desc", message: sortMessages.dataCadastroDesc},
  ];

  const caracteristicaFilter = [
    { id: "", message: messages[lang].all },
    { id: "sustentabilidade_algodao_bci", message: "Algodão Certificado BCI" },
    { id: "sustentabilidade_demais_atributos", message: "Demais Atributos Sustentáveis" }
  ];

  return (
    <Form className="px-3">
      <Row>
      <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{messages[lang].sustainabilityListPage.numeroPedido}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={messages[lang].sustainabilityListPage.numeroPedido}
                    type="text"
                    defaultValue={filters.numeroPedido}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, numeroPedido: event.target.value },
                    )}
                />
        </Form.Group>
        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{messages[lang].provider}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={messages[lang].provider}
                    type="text"
                    defaultValue={filters.fornecedor}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                    { ...filters, fornecedor: event.target.value },
                    )}
                />
        </Form.Group>
        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{messages[lang].sustainabilityListPage.tipoCertificado}</Form.Label>
                <Form.Control
                    as="select"
                    className="text-2 border-radius-full"
                    placeholder={messages[lang].sustainabilityListPage.tipoCertificado}
                    type="text"
                    defaultValue={filters.caracteristica}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, caracteristica: event.target.value },
                    )}
                >
                {
                  caracteristicaFilter.map(value => (
                    <option key={value.id} value={value.id}>{value.message}</option>
                  ))
                }
                </Form.Control>
        </Form.Group>
        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{messages[lang].sustainabilityListPage.statusAuditoria}</Form.Label>
                <Form.Control
                    as="select"
                    className="text-2 border-radius-full"
                    placeholder={messages[lang].sustainabilityListPage.statusAuditoria}
                    type="text"
                    defaultValue={filters.statusAuditoria}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, statusAuditoria: event.target.value },
                    )}
                >
                {
                  statusFilter.map(value => (
                    <option key={value.id} value={value.id}>{value.message}</option>
                  ))
                }
                </Form.Control>
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} className="mt-1">
              <Form.Label className="text-2">{messages[lang].sustainabilityListPage.dtPedidoInicial}</Form.Label>
                  <Form.Control
                      className="text-2 border-radius-full"
                      placeholder={messages[lang].sustainabilityListPage.dtPedidoInicial}
                      type="date"
                      defaultValue={filters.dtPedidoInicial}
                      onKeyDown={onEnterFilter}
                      onChange={event => setFilters(
                          { ...filters, dataPedidoInicial: event.target.value },
                      )}
                  />
          </Form.Group>

          <Form.Group as={Col} className="mt-1">
              <Form.Label className="text-2">{messages[lang].sustainabilityListPage.dtPedidoFinal}</Form.Label>
                  <Form.Control
                      className="text-2 border-radius-full"
                      placeholder={messages[lang].sustainabilityListPage.dtPedidoFinal}
                      type="date"
                      defaultValue={filters.dtPedidoFinal}
                      onKeyDown={onEnterFilter}
                      onChange={event => setFilters(
                          { ...filters, dataPedidoFinal: event.target.value },
                      )}
                  />
          </Form.Group>
          <Form.Group as={Col} className="mt-1">
              <Form.Label className="text-2">{messages[lang].sustainabilityListPage.dtCriacaoInicial}</Form.Label>
                  <Form.Control
                      className="text-2 border-radius-full"
                      placeholder={messages[lang].sustainabilityListPage.dtCriacaoInicial}
                      type="date"
                      defaultValue={filters.dtCriacaoInicial}
                      onKeyDown={onEnterFilter}
                      onChange={event => setFilters(
                          { ...filters, dataCriacaoInicial: event.target.value },
                      )}
                  />
          </Form.Group>

          <Form.Group as={Col} className="mt-1">
              <Form.Label className="text-2">{messages[lang].sustainabilityListPage.dtCriacaoFinal}</Form.Label>
                  <Form.Control
                      className="text-2 border-radius-full"
                      placeholder={messages[lang].sustainabilityListPage.dtCriacaoFinal}
                      type="date"
                      defaultValue={filters.dtCriacaoFinal}
                      onKeyDown={onEnterFilter}
                      onChange={event => setFilters(
                          { ...filters, dataCriacaoFinal: event.target.value },
                      )}
                  />
          </Form.Group>

          <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{sortMessages.sortBy}</Form.Label>
                <Form.Control
                    as="select"
                    className="text-2 border-radius-full"
                    placeholder={sortMessages.sortBy}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                    { ...filters, orderBy: event.target.value },
                    )}
                >
                {
                  sortSustainability.map(value => (
                    <option key={value.id} value={value.id}>{value.message}</option>
                  ))
                }
                </Form.Control>
        </Form.Group>
      </Row>
    </Form>
  );
}
